import React from "react";
import {withStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import guid from "../../../../../../utils/guid";
import PropTypes from 'prop-types';
import {TableBody, TableContainer} from "@material-ui/core";
import TableHeader from "../../../../../Common/TableHeader";
import t from "../../../../../../languages/pl";

const styles = theme => ({
    table: {
        marginTop: theme.spacing(2),
    }
});

const CustomCell = withStyles(theme => ({
    root: {
        textAlign: "center",
        height: 60,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    }
}))(props => <TableCell {...props}/>);


const RemarkTab = props => {
    const {classes, remarks} = props;
    const headers = ["Uwagi"];

    const printTable = (data) => {
        if (!Array.isArray(data) || data.length === 0)
            return (<TableRow>
                <TableCell
                    style={{textAlign: "center"}}
                    colSpan={3}
                >
                    {t.noDataInfo}
                </TableCell>
            </TableRow>);
        else {
            return (data.map(remark => {
                    return (<TableRow key={guid()}>
                            <CustomCell>{remark.uwaga}</CustomCell>
                        </TableRow>
                    );
                })
            );
        }
    };

    return (
        <Paper className={classes.table}>
            <TableContainer>
                <Table stickyHeader>
                    <TableHeader data={headers}/>
                    <TableBody>
                        {printTable(remarks)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};
RemarkTab.propTypes = {
    classes: PropTypes.object,
    remarks: PropTypes.array
};

export default withStyles(styles)(RemarkTab);
